// extracted by mini-css-extract-plugin
export default {"wrapper":"multi_select_wrapper__y6ZvZ"};